import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { WhenInView } from "../Tools/WhenInView";
import { Check } from "react-feather";

import {
  LargeTitle,
  InfoParagraph,
  SmallMargin,
  lightest,
  Contain,
  ContainWPadding,
  MediumTitle,
  light,
  grayText,
  Line,
  ThinLine,
  SmallTitle,
  primary,
  SpreadTitle
} from "../Tools/Variables";
import ControllImg from "../Images/controller.svg";
import MattressSpringsImg from "../Images/mattressSpringHole.svg";
import MattressThreadsImg from "../Images/mattressThread.svg";

const PointBg = styled.div`
  display: flex;
  position: relative;
  background: ${lightest};
  min-height: 200px;
  padding: 60px 0;
  width: 100%;
`;

const FlexCC = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 600px) {
    flex-direction: row;
  }
  @media screen and (max-width: 400px) {
    flex-direction: column;
  }
`;

const FlexArrayContainer = styled.div`
  min-height: 100px;
  display: flex;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

const FlexItem = styled.div`
  transition: 1s ease-in-out;
  opacity: ${props => (props.animate ? "1" : "0")};
  transform: ${props =>
    props.animate ? "translateX(0)" : "translateX(-50px)"};

  transition-delay: ${props => props.delay};
  flex: 1 0 0px;
  padding: 10px;
`;

const PointTitle = styled.h2`
  text-transform: uppercase;
  position: relative;
  font-weight: 500;
  color: ${grayText};
  font-size: 14px;
  margin: 0;
  padding: 0;
  margin-left: 15px;
`;
const PointParag = styled.p`
  font-weight: 300;
  color: #888;
  font-size: 14;
`;

class Point extends Component {
  render() {
    return (
      <FlexItem animate={this.props.animate} delay={this.props.delay}>
        <PointTitle>
          <div
            style={{
              position: "absolute",
              left: "-30px"
            }}
          >
            <Check size={20} />
          </div>
          {this.props.title}
        </PointTitle>
        <PointParag>{this.props.children}</PointParag>
      </FlexItem>
    );
  }
}

class SafeBuy extends Component {
  render() {
    return (
      <React.Fragment>
        <Contain>
          <SmallMargin />
          <SmallMargin />
        </Contain>
        <div
          style={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            transform: "translateY(50%)",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center"
          }}
        >
          <SpreadTitle>Varför Modilect?</SpreadTitle>
        </div>
        <WhenInView>
          {({ isInView }) => (
            <PointBg>
              <ContainWPadding>
                <FlexCC>
                  <FlexArrayContainer>
                    <Point
                      title={"Slipp svåra beslut"}
                      animate={isInView}
                      delay={"0s"}
                    >
                      Att köpa en ny säng innebär normalt många svåra
                      avvägningar. Med Modilect slipper du svåra val, som att
                      välja fasthet. Till skillnad från en konventionell säng
                      kan du alltid anpassa våra justerbara sängar utifrån hur
                      din kropp förändras. Genom hela livet.
                    </Point>
                    <Point
                      title={"Utifrån dina skiftande behov"}
                      animate={isInView}
                      delay={"0.2s"}
                    >
                      Har du en värkande rygg? Eller en ömmande axel? Inga
                      problem. Modilects premiumsäng kan alltid justeras exakt
                      utifrån dina personliga behov. T.ex. genom extra stöd för
                      rygg- och axelzoner.
                    </Point>
                    <Point
                      title={"En säng som passar alla"}
                      animate={isInView}
                      delay={"0.4s"}
                    >
                      En lyxig säng från Modilect är inte enbart perfekt för
                      dig. Oavsett om du har gäster på besök, ny partner eller
                      om sängen byter ägare så kan du följsamt forma den för att
                      passa personen som sover i den för stunden.
                    </Point>
                  </FlexArrayContainer>
                  <FlexArrayContainer>
                    <Point
                      title={"Välj fasthet beroende på tillfälle"}
                      animate={isInView}
                      delay={"0.1s"}
                    >
                      Ibland önskar man en hårdare säng, ibland en mjukare. Med
                      Modilects premiumsäng behöver du inte välja antingen eller.
                      Sjunk ner i ett djupt sömnmoln eller ät frukost på sängen
                      med hela familjen. Våra justerbara säng har därmed ett
                      spektrum som vanliga sängar saknar.
                    </Point>
                    <Point
                      title={"Rätt fasthet även på sikt"}
                      animate={isInView}
                      delay={"0.3s"}
                    >
                      Vi vet hur det är. Vanliga sängar mattas av med åren och
                      bibehåller inte den fasthet du en gång valde. Alla våra
                      premiumsängar är framtidssäkrade. Alltid med den exakta
                      fasthet som just du vill ha, utan att någonsin köpa ny
                      säng igen.
                    </Point>

                    <Point
                      title={"Garanterad komfort för stunden"}
                      animate={isInView}
                      delay={"0.3s"}
                    >
                      Att vara ordentligt utvilad är A och O för ett aktivt liv.
                      Varje dag är trots allt annorlunda, varje natt lika
                      viktig. Speciellt när du måste prestera dagen efter.
                      Modilect garanterar att du alltid får rätt fasthet.
                    </Point>
                  </FlexArrayContainer>
                </FlexCC>
              </ContainWPadding>
            </PointBg>
          )}
        </WhenInView>
      </React.Fragment>
    );
  }
}

export default SafeBuy;



// WEBPACK FOOTER //
// ./src/Home/SafeBuy.js